import { render, staticRenderFns } from "./barClockDesign.vue?vue&type=template&id=b39eb994&scoped=true"
import script from "./barClockDesign.vue?vue&type=script&lang=js"
export * from "./barClockDesign.vue?vue&type=script&lang=js"
import style0 from "./barClockDesign.vue?vue&type=style&index=0&id=b39eb994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39eb994",
  null
  
)

export default component.exports